import Alerts from './Alert.style';

export default Alerts;
